import { render, staticRenderFns } from "./CustomServiceManage.vue?vue&type=template&id=896634bc&scoped=true"
import script from "./CustomServiceManage.vue?vue&type=script&lang=js"
export * from "./CustomServiceManage.vue?vue&type=script&lang=js"
import style0 from "./CustomServiceManage.vue?vue&type=style&index=0&id=896634bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "896634bc",
  null
  
)

export default component.exports